const countries = [
    { code: "AFG", name: "Afghanistan" },
    { code: "ALB", name: "Albania" },
    { code: "DZA", name: "Algeria" },
    { code: "ASM", name: "American Samoa" },
    { code: "AND", name: "Andorra" },
    { code: "AGO", name: "Angola" },
    { code: "AIA", name: "Anguilla" },
    { code: "ATA", name: "Antarctica" },
    { code: "ATG", name: "Antigua" },
    { code: "ARG", name: "Argentina" },
    { code: "ARM", name: "Armenia" },
    { code: "ABW", name: "Aruba" },
    { code: "AUS", name: "Australia" },
    { code: "AUT", name: "Austria" },
    { code: "AZE", name: "Azerbaijan" },
    { code: "BHS", name: "Bahamas" },
    { code: "BHR", name: "Bahrain" },
    { code: "BGD", name: "Bangladesh" },
    { code: "BRB", name: "Barbados" },
    { code: "BLR", name: "Belarus" },
    { code: "BEL", name: "Belgium" },
    { code: "BLZ", name: "Belize" },
    { code: "BEN", name: "Benin" },
    { code: "BMU", name: "Bermuda" },
    { code: "BTN", name: "Bhutan" },
    { code: "BOL", name: "Bolivia" },
    { code: "BIH", name: "Bosnia" },
    { code: "BWA", name: "Botswana" },
    { code: "BRA", name: "Brazil" },
    { code: "BRN", name: "Brunei" },
    { code: "BGR", name: "Bulgaria" },
    { code: "BFA", name: "Burkina Faso" },
    { code: "BDI", name: "Burundi" },
    { code: "KHM", name: "Cambodia" },
    { code: "CMR", name: "Cameroon" },
    { code: "CAN", name: "Canada" },
    { code: "CPV", name: "Cape Verde" },
    { code: "CHL", name: "Chile" },
    { code: "CHN", name: "China" },
    { code: "COL", name: "Colombia" },
    { code: "COM", name: "Comoros" },
    { code: "COG", name: "Congo" },
    { code: "CRI", name: "Costa Rica" },
    { code: "CIV", name: "Côte d'Ivoire" },
    { code: "HRV", name: "Croatia" },
    { code: "CUB", name: "Cuba" },
    { code: "CYP", name: "Cyprus" },
    { code: "CZE", name: "Czech Republic" },
    { code: "DNK", name: "Denmark" },
    { code: "DJI", name: "Djibouti" },
    { code: "DMA", name: "Dominica" },
    { code: "DOM", name: "Dominican Republic" },
    { code: "ECU", name: "Ecuador" },
    { code: "EGY", name: "Egypt" },
    { code: "SLV", name: "El Salvador" },
    { code: "EST", name: "Estonia" },
    { code: "ETH", name: "Ethiopia" },
    { code: "FIN", name: "Finland" },
    { code: "FRA", name: "France" },
    { code: "DEU", name: "Germany" },
    { code: "GHA", name: "Ghana" },
    { code: "GRC", name: "Greece" },
    { code: "GRL", name: "Greenland" },
    { code: "GTM", name: "Guatemala" },
    { code: "HTI", name: "Haiti" },
    { code: "HND", name: "Honduras" },
    { code: "HUN", name: "Hungary" },
    { code: "ISL", name: "Iceland" },
    { code: "IND", name: "India" },
    { code: "IDN", name: "Indonesia" },
    { code: "IRN", name: "Iran" },
    { code: "IRQ", name: "Iraq" },
    { code: "IRL", name: "Ireland" },
    { code: "ITA", name: "Italy" },
    { code: "JPN", name: "Japan" },
    { code: "JOR", name: "Jordan" },
    { code: "KAZ", name: "Kazakhstan" },
    { code: "KEN", name: "Kenya" },
    { code: "KOR", name: "Korea, South" },
    { code: "PRK", name: "Korea, North" },
    { code: "KWT", name: "Kuwait" },
    { code: "KGZ", name: "Kyrgyzstan" },
    { code: "LAO", name: "Laos" },
    { code: "LVA", name: "Latvia" },
    { code: "LBN", name: "Lebanon" },
    { code: "LBY", name: "Libya" },
    { code: "LIE", name: "Liechtenstein" },
    { code: "LTU", name: "Lithuania" },
    { code: "LUX", name: "Luxembourg" },
    { code: "MAC", name: "Macau" },
    { code: "MYS", name: "Malaysia" },
    { code: "MLI", name: "Mali" },
    { code: "MLT", name: "Malta" },
    { code: "MEX", name: "Mexico" },
    { code: "MDA", name: "Moldova" },
    { code: "MCO", name: "Monaco" },
    { code: "MNG", name: "Mongolia" },
    { code: "MNE", name: "Montenegro" },
    { code: "MAR", name: "Morocco" },
    { code: "MOZ", name: "Mozambique" },
    { code: "MMR", name: "Myanmar" },
    { code: "NLD", name: "Netherlands" },
    { code: "NZL", name: "New Zealand" },
    { code: "NIC", name: "Nicaragua" },
    { code: "NGA", name: "Nigeria" },
    { code: "NOR", name: "Norway" },
    { code: "OMN", name: "Oman" },
    { code: "PAK", name: "Pakistan" },
    { code: "PAN", name: "Panama" },
    { code: "PER", name: "Peru" },
    { code: "PHL", name: "Philippines" },
    { code: "POL", name: "Poland" },
    { code: "PRT", name: "Portugal" },
    { code: "QAT", name: "Qatar" },
    { code: "ROU", name: "Romania" },
    { code: "RUS", name: "Russia" },
    { code: "SAU", name: "Saudi Arabia" },
    { code: "SGP", name: "Singapore" },
    { code: "ZAF", name: "South Africa" },
    { code: "ESP", name: "Spain" },
    { code: "SWE", name: "Sweden" },
    { code: "CHE", name: "Switzerland" },
    { code: "TUR", name: "Turkey" },
    { code: "UKR", name: "Ukraine" },
    { code: "ARE", name: "United Arab Emirates" },
    { code: "GBR", name: "United Kingdom" },
    { code: "USA", name: "United States" },
    { code: "VNM", name: "Vietnam" },
    { code: "YEM", name: "Yemen" },
    { code: "ZMB", name: "Zambia" },
    { code: "ZWE", name: "Zimbabwe" }
  ];
  
  export default countries;
  